export default "varying vec2 v_uv;\n\nvoid main() {\n\tv_uv = uv;\n\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}\n\t";